import React from 'react'
import {withDropdown} from '@modifi/ui'

import InfoDropdownHeader, {InfoDropdownHeaderProps} from './InfoDropdownHeader'

export const InfoDropdown = withDropdown({
  toggleComponent: InfoDropdownHeader,
})(
  ({
    dropdownToggle: Toggler,
    // @ts-expect-error to be fixed
    filterType,
    ...props
  }: {
    dropdownToggle: React.FC<InfoDropdownHeaderProps>
  }) => (
    // @ts-expect-error types not generated properly
    <Toggler data-ident={`${filterType}-filter`} filterType={filterType} {...props} />
  )
)
